import { Injectable } from '@angular/core';
import {
  NavigationExtras,
  PRIMARY_OUTLET,
  Router,
  UrlTree,
} from '@angular/router';
import { compact } from 'lodash';

const Url = require('domurl');

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  constructor(private _router: Router) {}

  serializeParams(params: {}, prefix?: string): string {
    const str = [];

    for (const p in params) {
      if (params.hasOwnProperty(p)) {
        const k = prefix ? prefix + '[' + p + ']' : p;
        const v = params[p];

        str.push(
          typeof v === 'object'
            ? this.serializeParams(v, k)
            : encodeURIComponent(k) + '=' + encodeURIComponent(v)
        );
      }
    }

    return compact(str).join('&');
  }

  parse(url: string): UrlTree {
    return this._router.parseUrl(url);
  }

  parseUrlToRoute(
    url: string,
    extras: NavigationExtras = {}
  ): { route: string[]; navigationExtras } {
    const urlTree = this.parse(url);
    const primaryRoute = urlTree.root.children[PRIMARY_OUTLET];
    const urlPaths = primaryRoute.segments.map((urlSegment) => urlSegment.path);
    const navigationExtras = {
      ...extras,
      queryParams: urlTree.queryParams,
    };

    return {
      route: urlPaths,
      navigationExtras,
    };
  }

  parseExternalUrl(url: string) {
    return new Url(url);
  }
}
